import React from "react"

import HeroImage from "../../../../assets/images/hero-image.png"
import HeaderBg from "../../../../assets/images/header__bg.png"
import Button from "../../../common/Button"

import "./style.scss"

export const Banner = () => {
	return (
		<div className="banner">
			<div className="banner__container">
				<div className="banner__content">
					<h3>Welcome to Stefit</h3>
					<h1>Senior Full Stack Developer</h1>
					<h5>
						I am a <span className="text-highlight">trustworthy</span>, <span className="text-highlight">proactive</span>, and <span className="text-highlight">future-oriented</span> full stack developer who delivers <span className="text-highlight">high-quality code </span>
						with <span className="text-highlight">reliability, security, and adaptability</span> in mind. you can see my skills on my{" "} 
						<a
							className="github"
							href="https://github.com/bytestefano"
							target="_blank"
							rel="noopener noreferrer">
							Github.
						</a>{" "}
						<br />
						<span className="text-highlight">Stefit will make you get your dream done at one time.</span>
					</h5>
					<a href="#recent-projects">
						<Button label="View projects" variant="outline" />
					</a>
				</div>
				<div className="banner__image">
					<img src={HeroImage} alt="Bikash Sharma smiling" />
				</div>
			</div>
			<img
				src={HeaderBg}
				alt="code abstract background"
				className="banner__bg"
			/>
		</div>
	)
}
export default Banner
